import { styled } from "@mui/material/styles";

export const Kbd = styled("kbd")({
  backgroundColor: "transparent",
  color: "currentColor",
  border: "1px solid currentColor",
  boxShadow: "0 1px 0 currentColor",
  borderRadius: 4,
  minWidth: 20,
  height: 20,
  padding: "0 5px",
  fontSize: "0.75rem",
  fontFamily: "inherit",
  fontWeight: 600,
  lineHeight: 1,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textTransform: "uppercase",
});
